<template><section><template>
<h3>标签</h3>
<div class="bs-docs-section" id="标签">
<blockquote>
<p>标签</p>
</blockquote>
<div class="bs-example">
  <n3-label>Default</n3-label>
  <n3-label type="primary">primary</n3-label>
  <n3-label type="danger">danger</n3-label>
  <n3-label type="success">success</n3-label>
  <n3-label type="info">info</n3-label>
  <n3-label type="warning">warning</n3-label>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-label</span>&gt;</span>Default<span class="hljs-tag">&lt;/<span class="hljs-name">n3-label</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-label</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span>&gt;</span>primary<span class="hljs-tag">&lt;/<span class="hljs-name">n3-label</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-label</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"danger"</span>&gt;</span>danger<span class="hljs-tag">&lt;/<span class="hljs-name">n3-label</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-label</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"success"</span>&gt;</span>success<span class="hljs-tag">&lt;/<span class="hljs-name">n3-label</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-label</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"info"</span>&gt;</span>info<span class="hljs-tag">&lt;/<span class="hljs-name">n3-label</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-label</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"warning"</span>&gt;</span>warning<span class="hljs-tag">&lt;/<span class="hljs-name">n3-label</span>&gt;</span>
</code></pre>
<h3>label参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>type</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">default</code></td>
<td>颜色</td>
</tr>
<tr>
<td>hover</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td></td>
</tr>
</tbody>
</table>
<blockquote>
<p>标签组</p>
</blockquote>
<div class="bs-example">
  <n3-tags v-model="list"></n3-tags>
  <n3-tags v-model="list" type="primary"></n3-tags>
  <n3-tags v-model="list" type="success"></n3-tags>
  <n3-tags v-model="list" type="danger"></n3-tags>
  <n3-tags v-model="list" type="warning"></n3-tags>
  <n3-tags v-model="list" removable="" type="primary"></n3-tags>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-tags</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"list"</span> &gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-tags</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-tags</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"list"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-tags</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-tags</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"list"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"success"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-tags</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-tags</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"list"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"danger"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-tags</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-tags</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"list"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"warning"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-tags</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-tags</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"list"</span> <span class="hljs-attr">removable</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-tags</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">list</span>: [{
        <span class="hljs-attr">value</span>: <span class="hljs-string">'1'</span>,
        <span class="hljs-attr">label</span>: <span class="hljs-string">'1'</span>
      }, {
        <span class="hljs-attr">value</span>: <span class="hljs-string">'2'</span>,
        <span class="hljs-attr">label</span>: <span class="hljs-string">'2'</span>
      }, {
        <span class="hljs-attr">value</span>: <span class="hljs-string">'3'</span>,
        <span class="hljs-attr">label</span>: <span class="hljs-string">'3'</span>
      }, {
        <span class="hljs-attr">value</span>: <span class="hljs-string">'4'</span>,
        <span class="hljs-attr">label</span>: <span class="hljs-string">'4'</span>,
        <span class="hljs-attr">disabled</span>: <span class="hljs-literal">true</span>
      }]
    }
  }
}
</code></pre>
<h3>tags参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>type</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">default</code></td>
<td>颜色</td>
</tr>
<tr>
<td>value</td>
<td><code v-pre="">Array</code></td>
<td><code v-pre="">[]</code></td>
<td>内容数组</td>
</tr>
<tr>
<td>size</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>大小 sm,lg,xl</td>
</tr>
<tr>
<td>removable</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>是否可删除</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      list: [{
        value: '1',
        label: '1'
      }, {
        value: '2',
        label: '2'
      }, {
        value: '3',
        label: '3'
      }, {
        value: '4',
        label: '4',
        disabled: true
      }]
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3TagsDocs.md?d2a986d6